import ApiService from '@/services/ApiService';

const namespace = 'files';

const getAllFiles = (callback, errorCallback) => {
    ApiService.get(`${namespace}/`, [], callback, errorCallback);
};

const downloadFile = (fileId, headers, callback, errorCallback) => {
    ApiService.download(`${namespace}/${fileId}`, headers, [], callback, errorCallback);
}

const deleteFile = (fileId, callback, errorCallback) => {
    ApiService.remove(`${namespace}/${fileId}`, callback, errorCallback);
}

const uploadFile = (data, callback, errorCallback) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
          }
    };

    ApiService.uploadFile(`${namespace}`, data, callback, errorCallback, config);
}
export default {
    getAllFiles,
    downloadFile,
    uploadFile,
    deleteFile,
};



// WEBPACK FOOTER //
// ./src/infrastructure/fileuploads/services/FileUploadsService.js